import { render, staticRenderFns } from "./WpUninstallDialog.vue?vue&type=template&id=7dd9c118&"
import script from "./WpUninstallDialog.vue?vue&type=script&lang=ts&"
export * from "./WpUninstallDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports